import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'discard-site-branch' as const;

const argumentZod = z.object({
  siteBranchId: z
    .string()
    .min(1)
    .describe(
      'Site-branch id from list-site-branches. Hard-deletes that live site-scope branch (Releases).'
    ),
});

export const discardSiteBranchManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Discard site branch',
  family: 'site-branches',
  llmTool: {
    name: toolName,
    description:
      'Discards (hard-deletes) a live site-scope branch (Releases) for the current site. Sync — returns no body on success. Merged branches cannot be discarded (409). Distinct from delete-branch, which enqueues an async page-branch delete.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.SITE_BRANCHES,
  requiredScopes: ['branches:delete'],
  permission: [
    {
      resource: 'SiteBranch',
      action: 'manage',
      resolveResources: (args) => [{type: 'SiteBranch', id: args.siteBranchId}],
    },
  ],
  confirmBeforeExecuting: true, // Irreversible hard delete
  isConcurrencySafe: () => false,
  isReadOnly: () => false,
});

export type DiscardSiteBranchArgumentType = z.infer<typeof argumentZod>;
